import { useQuery } from '@tanstack/react-query';
import * as React from 'react';
import { useObservable } from 'react-use-observable';
import { IS_PROD } from 'settings';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import tokenService from 'v2/services/token';

function QualificationValidation() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [accountsId] = useObservable(() => tokenService.getAccountsId(), []);
  const hasPendingQualification = useQuery(['qualificationRedirect'], () => eduzzAccountsService.checkPendingQualification(user.id), {
    enabled: !!accountsId,
  });

  const redirectUserToQualification = React.useCallback((accountId: string, qualificationUrl: string) => {
    const params = `?userId=${accountId}&utm_source=myeduzz`;
    qualificationUrl = !IS_PROD ? qualificationUrl.replace('qualificacao.eduzz.com/', 'qualificacao.eduzz.com/version-test/') : qualificationUrl;
    window.location.href = `${qualificationUrl}${params}`;
  }, []);

  React.useEffect(() => {
    if (!user) return;
    if (user.is_support || hasPendingQualification.isLoading) return;

    const shouldRedirect = hasPendingQualification.data && hasPendingQualification.data.pendingQualificationUrl;

    if (shouldRedirect) {
      redirectUserToQualification(accountsId, hasPendingQualification.data.pendingQualificationUrl);
    }
  }, [redirectUserToQualification, accountsId, user, hasPendingQualification]);

  if (!user) return null;

  return <></>;
}

export { QualificationValidation };
